import type { JSX } from "solid-js";

export function Field(props: {
  label: string;
  children: JSX.Element;
  grow?: boolean;
}) {
  return (
    <div class={`tov-field ${props.grow ? "grow" : ""}`}>
      <span class="tov-field-label">{props.label}</span>
      {props.children}
    </div>
  );
}
